const { banks } = require('@transfeeradev/api-enums');
const Default = require('./lib/Default');
const Santander = require('./lib/Santander');
const Itau = require('./lib/Itau');
const BancoDoBrasil = require('./lib/BancoDoBrasil');
const Caixa = require('./lib/Caixa');
const Sicoob = require('./lib/Sicoob');
const Bradesco = require('./lib/Bradesco');
const NuPagamentos = require('./lib/NuPagamentos');
const C6Bank = require('./lib/C6Bank');
const SchemaValidation = require('./lib/SchemaValidation');
const BankCodeService = require('./lib/services/BankCodeService');

module.exports = class BankValidation {
  constructor(data) {
    this._data = data;
  }

  _getBankCodeFromISPB(ispb) {
    const result = Object.keys(banks).find(bank => {
      return banks[bank].ispb === ispb;
    });

    return result ? banks[result].code : null;
  }

  validate({ isTED } = {}) {
    isTED = isTED ? true : false;
    const data = this._data;
    let instance;

    const bankCode = data.bank_code ? data.bank_code : this._getBankCodeFromISPB(data.bank_ispb);

    switch (BankCodeService.format(bankCode)) {
      case BankCodeService.format(banks.SANTANDER.code):
        instance = new Santander(data);
        break;

      case BankCodeService.format(banks.ITAU.code):
        instance = new Itau(data);
        break;

      case BankCodeService.format(banks.BANCO_DO_BRASIL.code):
        instance = new BancoDoBrasil(data, {
          isTED
        });
        break;

      case BankCodeService.format(banks.CAIXA_ECONOMICA.code):
        instance = new Caixa(data);
        break;

      case BankCodeService.format(banks.SICOOB.code):
        instance = new Sicoob(data);
        break;

      case BankCodeService.format(banks.BRADESCO.code):
        instance = new Bradesco(data);
        break;

      case BankCodeService.format(banks.NU_PAGAMENTO.code):
        instance = new NuPagamentos(data);
        break;

      case BankCodeService.format(banks.C6_BANK.code):
        instance = new C6Bank(data);
        break;

      default:
        instance = new Default(null, data, bankCode);
        break;
    }

    return instance.validate();
  }

  validateSchema(ignoreErrorsWithSuggestions) {
    const bankCode = this._data.bank_code ? this._data.bank_code : this._getBankCodeFromISPB(this._data.bank_ispb);
    return new SchemaValidation(this._data, bankCode, ignoreErrorsWithSuggestions).validate();
  }
};

module.exports.Santander = Santander;
module.exports.Itau = Itau;
module.exports.BancoDoBrasil = BancoDoBrasil;
module.exports.Caixa = Caixa;
module.exports.Sicoob = Sicoob;
module.exports.Bradesco = Bradesco;
module.exports.NuPagamentos = NuPagamentos;
module.exports.C6Bank = C6Bank;
module.exports.SchemaValidation = SchemaValidation;
module.exports.BankCodeService = BankCodeService;
